import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portlet-main-content',
  templateUrl: './portlet-main-content.component.html',
  styleUrls: ['./portlet-main-content.component.css']
})
export class PortletMainContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
